const Ambalath=[
{     src: 'https://pix8.agoda.net/hotelImages/4990856/0/fdec6e16e8ce422e6459cb5e067ea725.jpg?va=1&ce=3&s=1024x',
      alt: 'Daan Ambalath',
    },
    { src: 'https://pix8.agoda.net/hotelImages/4990856/0/c44d60550d96fa643efcb47663ffdc80.jpg?va=1&ce=3&s=1024x',   alt: 'Daan Ambalath',
    },
    {
  src: 'https://q-xx.bstatic.com/xdata/images/hotel/max1024x768/171967987.jpg?k=628c1495a8cd1ae35d0df905a36896b06c381d5161210f8da1828c290f80379f&o=&s=1024x',    alt: 'Daan Ambalath',
    },
    {
  src: 'https://pix8.agoda.net/hotelImages/4990856/0/27418a144c75a5c79968b63f04a18f91.jpg?va=1&ce=3&s=1024x',      alt: 'Daan Ambalath',
    },
    {
  src: 'https://q-xx.bstatic.com/xdata/images/hotel/max1024x768/799825497.jpg?k=0be4aa89b9e105b27fc577ba8dfc66c2c146306ccc581c4fcf1144025951e9c6&o=&s=1024x',    alt: 'Daan Ambalath'
    }, {
  src: 'https://pix8.agoda.net/hotelImages/4990856/0/d1b7fa9b0e126d95243d39f7cddad8a0.jpg?va=1&ce=3&s=1024x',     alt: 'Daan Ambalath',
    }, 

]

export default Ambalath;
